export default "__VITE_ASSET__7a2c28c7__"